export const translations = {
  pt: {
    // Login Page
    login: {
      title: "VolleyPro Analytics",
      subtitle: "Sistema de Avaliação de Jogadores",
      playerTab: "SOU JOGADOR",
      evaluatorTab: "SOU AVALIADOR",
      email: "Email",
      password: "Senha",
      enterButton: "Entrar",
      registering: "Cadastrando...",
      entering: "Entrando...",
      invalidCredentials: "Credenciais inválidas",
      registerSuccess: "Cadastro enviado! Aguarde aprovação do administrador.",
      // Registration
      register: "Cadastrar",
      firstName: "Nome",
      lastName: "Sobrenome",
      position: "Posição",
      position2: "2ª Posição (opcional)",
      phone: "Telefone",
      birthDate: "Data de Nascimento",
      photo: "Foto",
      selectPhoto: "Selecionar Foto",
      gallery: "Galeria",
      camera: "Câmera",
      requiredFields: "* Campos obrigatórios",
      awaitingApproval: "Seu cadastro será analisado pelo admin",
      alreadyHaveAccount: "Já tem conta?",
      dontHaveAccount: "Não tem conta?",
      clickHere: "Clique aqui",
      // Player login
      findYourName: "Encontre seu nome na lista e entre com a senha",
      searchYourName: "Buscar seu nome",
      typeYourName: "Digite seu nome...",
      selectYourName: "Selecione seu nome",
      chooseYourName: "Escolha seu nome...",
      enterPassword: "Digite a senha",
      selectPlayer: "Selecione seu nome na lista",
      // Evaluator login
      evaluatorAccess: "Acesso para técnicos, avaliadores e administradores",
    },
    // Positions
    positions: {
      ponteiro: "Ponteiro",
      oposto: "Oposto",
      central: "Central",
      levantador: "Levantador",
      libero: "Líbero",
    },
    // Navigation
    nav: {
      home: "Início",
      players: "Jogadores",
      evaluators: "Avaliadores",
      evaluate: "Avaliar",
      ranking: "Ranking",
      statistics: "Estatísticas",
      gameday: "Times do Dia",
      permissions: "Permissões",
      settings: "Configurações",
      logout: "Sair",
    },
    // Dashboard
    dashboard: {
      welcome: "Bem-vindo",
      totalPlayers: "Total de Jogadores",
      totalEvaluations: "Total de Avaliações",
      pendingApproval: "Aguardando Aprovação",
      recentActivity: "Atividade Recente",
    },
    // Players
    players: {
      title: "Jogadores",
      searchPlaceholder: "Buscar jogador...",
      noPlayers: "Nenhum jogador encontrado",
      average: "Média",
      evaluations: "avaliações",
      edit: "Editar",
      delete: "Excluir",
      history: "Histórico",
      makeEvaluator: "Tornar Avaliador",
      pending: "Pendentes",
      approved: "Aprovados",
      playersFound: "jogador(es)",
    },
    // Evaluation
    evaluation: {
      title: "Avaliar Jogador",
      selectPlayer: "Selecione um jogador",
      skills: "Habilidades",
      attack: "Ataque",
      pass: "Passe",
      defense: "Defesa",
      serve: "Saque",
      block: "Bloqueio",
      setting: "Toque",
      skill: "Técnica",
      comments: "Comentários",
      commentsPlaceholder: "Observações sobre o jogador...",
      submit: "Enviar Avaliação",
      submitting: "Enviando...",
      success: "Avaliação enviada com sucesso!",
      error: "Erro ao enviar avaliação",
    },
    // Ranking
    ranking: {
      title: "Ranking de Jogadores",
      position: "Posição",
      player: "Jogador",
      overall: "Média Geral",
      compare: "Comparar",
      selectPlayer1: "Selecione o Jogador 1",
      selectPlayer2: "Selecione o Jogador 2",
      compareButton: "Comparar Jogadores",
    },
    // Game Day
    gameday: {
      title: "Times do Dia",
      selectPlayers: "Selecionar Jogadores",
      generateTeams: "Gerar Times Equilibrados",
      generating: "Gerando...",
      publishTeams: "Publicar Times",
      publishing: "Publicando...",
      published: "Times publicados!",
      shareWhatsApp: "Compartilhar no WhatsApp",
      team: "Time",
      power: "Power",
      winProbability: "Prob. Vitória",
      mvp: "MVP",
      recentGames: "Jogos Recentes",
      location: "Local",
      startTime: "Horário Início",
      endTime: "Horário Fim",
    },
    // Common
    common: {
      save: "Salvar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      delete: "Excluir",
      edit: "Editar",
      back: "Voltar",
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      yes: "Sim",
      no: "Não",
      all: "Todos",
      none: "Nenhum",
      search: "Buscar",
      filter: "Filtrar",
      noData: "Sem dados",
      language: "Idioma",
      select: "Selecione",
      optional: "Opcional",
    },
    // Admin - Evaluations Panel
    evaluationsPanel: {
      title: "Painel de Avaliações",
      subtitle: "Visualize todas as avaliações de jogadores realizadas na plataforma",
      searchPlayer: "Digite o nome do jogador...",
      allPlayers: "Todos os jogadores",
      allEvaluators: "Todos os avaliadores",
      last30: "Últimos 30 dias",
      last90: "Últimos 90 dias",
      allPeriod: "Todos",
      results: "resultado(s)",
      selectByEvaluator: "Selecionar por Avaliador",
      selectAll: "Selecionar Todos",
      exportEvaluations: "Exportar Avaliações",
      exportPlayers: "Exportar Jogadores",
      exportPDF: "Exportar PDF",
      allEvaluations: "Todas as Avaliações",
      viewDetails: "Ver detalhes",
      edit: "Editar",
      deleteSelected: "Excluir Selecionados",
      confirmBulkDelete: "Excluir Avaliações em Lote",
      cannotUndo: "Esta ação não pode ser desfeita!",
      noEvaluations: "Nenhuma avaliação encontrada",
      adjustFilters: "Ajuste os filtros para encontrar avaliações",
    },
    // Admin - Game Registrations
    gameRegistrations: {
      title: "Inscrições para Jogos",
      subtitle: "Abra inscrições e gerencie jogadores",
      enabled: "Liberadas",
      disabled: "Bloqueadas",
      openRegistrations: "Abrir Inscrições",
      newRegistrations: "Abrir Novas Inscrições",
      gameTitle: "Título",
      date: "Data",
      time: "Horário",
      location: "Local",
      locationPlaceholder: "Quadra, endereço...",
      maxPlayers: "Máximo de Jogadores",
      guestDeadline: "Prazo Convidados",
      guestDeadlineHint: "Até esse prazo, só membros do grupo podem se inscrever.",
      games: "Jogos",
      noRegistrations: "Nenhuma inscrição aberta",
      clickOpen: "Clique em 'Abrir Inscrições'",
      open: "Aberto",
      closed: "Fechado",
      waiting: "espera",
      selectGame: "Selecione um jogo para ver detalhes",
      orOpenNew: "Ou abra novas inscrições",
      generateTeams: "Gerar Times",
      closeBtn: "Fechar",
      reopenBtn: "Reabrir",
      payments: "Pagamentos",
      registeredPlayers: "Jogadores Inscritos",
      spots: "vaga(s)",
      noPlayersRegistered: "Nenhum jogador inscrito",
      waitlistTitle: "Lista de Espera",
      emptyWaitlist: "Lista de espera vazia",
      promoteSpots: "Promover Vagas",
      member: "Membro",
      guest: "Convidado",
      paid: "Pago",
      hoursLeft: "h restantes",
      expiring: "Expirando",
      editGameTitle: "Editar Jogo",
      saveChanges: "Salvar Alterações",
      deadlineExpired: "expirado - vagas abertas para todos",
      membersOnly: "somente membros",
      defaultGameTitle: "Jogo do Dia",
    },
    // Admin - Evaluators
    evaluatorsAdmin: {
      title: "Avaliadores",
      subtitle: "Gerencie avaliadores, técnicos e administradores",
      addEvaluator: "Adicionar Avaliador",
      newEvaluator: "Novo Avaliador",
      name: "Nome",
      email: "Email",
      password: "Senha",
      role: "Nível de Acesso",
      admin: "Administrador",
      adminDesc: "Acesso total",
      coach: "Técnico",
      coachDesc: "Times, estatísticas, jogadores",
      evaluator: "Avaliador",
      evaluatorDesc: "Apenas avaliar",
      linkedPlayer: "Jogador Vinculado",
      link: "Vincular",
      unlink: "Desvincular",
      active: "Ativo",
      inactive: "Inativo",
      editEvaluator: "Editar Avaliador",
      noEvaluators: "Nenhum avaliador cadastrado",
      searchPlaceholder: "Buscar avaliador...",
    },
    // Admin - Permissions
    permissionsAdmin: {
      title: "Gerenciar Permissões",
      subtitle: "Configure o acesso de cada nível de avaliador",
      adminOnly: "Apenas Admin",
      save: "Salvar Permissões",
    },
    // Admin - Payments
    paymentsAdmin: {
      title: "Pagamentos",
      subtitle: "Gerencie todos os pagamentos dos jogadores",
      totalCollected: "Total Arrecadado",
      totalPending: "Total Pendente",
      paymentHistory: "Histórico de Pagamentos",
      newPayment: "Novo Pagamento",
      player: "Jogador",
      amount: "Valor",
      dateLabel: "Data",
      description: "Descrição",
      status: "Status",
      paid: "Pago",
      pending: "Pendente",
      noPayments: "Nenhum pagamento encontrado",
      gameFee: "Taxa do Jogo",
    },
    // Admin - Weekly Report
    weeklyReport: {
      title: "Relatório Semanal",
      subtitle: "Configure o envio automático de relatórios",
      enabled: "Ativado",
      disabled: "Desativado",
      monday: "Segunda-feira",
      tuesday: "Terça-feira",
      wednesday: "Quarta-feira",
      thursday: "Quinta-feira",
      friday: "Sexta-feira",
      saturday: "Sábado",
      sunday: "Domingo",
      recipients: "Destinatários",
      addEmail: "Adicionar e-mail",
      save: "Salvar Configurações",
      sendNow: "Enviar Agora",
      sending: "Enviando...",
    },
    // Player Dashboard
    playerDashboard: {
      editProfile: "Editar Perfil",
      yourFirstName: "Seu primeiro nome",
      yourLastName: "Seu sobrenome",
      mainPosition: "Posição Principal",
      secondaryPosition: "Posição Secundária",
      changePassword: "Alterar Senha",
      newPassword: "Nova Senha",
      enterNewPassword: "Digite a nova senha",
      confirmPassword: "Confirmar Senha",
      confirmNewPassword: "Confirme a nova senha",
      myInfo: "Minhas Informações",
      noContactInfo: "Clique no ícone de editar ao lado do seu nome para adicionar email e telefone.",
      games: "Jogos",
      teammates: "Companheiros",
      lineups: "Escalações",
      upcomingGames: "Próximos Jogos",
      register: "Inscrever-se",
      unregister: "Cancelar Inscrição",
      registered: "Inscrito",
      full: "Lotado",
      spots: "vagas",
      calendar: "Calendário",
      gameCalendar: "Calendário de Jogos",
      mostPlayedWith: "Mais jogou com",
      leastPlayedWith: "Menos jogou com",
      gamesPlayed: "jogos",
      noTeammates: "Jogue mais partidas para ver estatísticas de companheiros!",
      registerSuccess: "Inscrição confirmada!",
      unregisterSuccess: "Inscrição cancelada",
      noGameOnDate: "Nenhum jogo nesta data",
      legend: "Legenda",
      scheduledGame: "Jogo agendado",
      youParticipated: "Você participou",
      myTeams: "Minhas Equipes",
      noTeamsYet: "Você ainda não participou de nenhuma equipe",
      gameOfDay: "Jogo do Dia",
      youPlayed: "Você jogou",
      confirmUnregister: "Tem certeza que deseja cancelar a inscrição?",
      registrationsClosed: "Inscrições encerradas",
      yourTeam: "Seu Time",
      viewAllTeams: "Ver todos os times",
    },
    // Toast Messages
    toasts: {
      // Success messages
      playerApproved: "Jogador aprovado com sucesso! Um email foi enviado.",
      playerRejected: "Cadastro rejeitado e removido",
      playerAdded: "Jogador adicionado!",
      playerUpdated: "Jogador atualizado!",
      playerDeleted: "Jogador excluído!",
      playersDeleted: "jogadores excluídos!",
      photoUploaded: "Foto enviada para a nuvem!",
      profileUpdated: "Perfil atualizado!",
      passwordChanged: "Senha alterada com sucesso!",
      evaluationSent: "Avaliação enviada com sucesso!",
      evaluationDeleted: "Avaliação excluída com sucesso",
      evaluatorCreated: "Avaliador cadastrado com sucesso!",
      evaluatorDeleted: "Avaliador excluído com sucesso!",
      evaluatorActivated: "Avaliador ativado",
      evaluatorDeactivated: "Avaliador desativado",
      roleUpdated: "Nível de acesso atualizado",
      permissionsSaved: "Permissões salvas com sucesso!",
      teamsGenerated: "Times gerados! Clique em 'Publicar' para enviar aos jogadores.",
      teamsPublished: "Times publicados! A ordem dos jogadores foi salva.",
      openingWhatsApp: "Abrindo WhatsApp...",
      linkCopied: "Link copiado!",
      inviteSent: "Convite enviado com sucesso!",
      emailResent: "Email reenviado!",
      inviteDeleted: "Convite excluído",
      referencePlayerUpdated: "Jogador parâmetro atualizado",
      referenceSetterUpdated: "Levantador parâmetro atualizado",
      madeEvaluator: "transformado em",
      successfully: "com sucesso!",
      historyDeleted: "Histórico apagado com sucesso",
      registrationSuccess: "Cadastro realizado com sucesso!",
      linkedPlayer: "Avaliador vinculado ao jogador com sucesso!",
      unlinkedPlayer: "Vínculo removido com sucesso!",
      configSaved: "Configurações salvas com sucesso!",
      reportSent: "Relatório enviado com sucesso!",
      eventCreated: "Evento criado!",
      eventUpdated: "Evento atualizado!",
      eventDeleted: "Evento excluído!",
      attendanceSaved: "Frequência salva com sucesso!",
      teamCreated: "Time cadastrado com sucesso!",
      teamDeleted: "Time excluído com sucesso!",
      playerAssigned: "Jogador atribuído ao time!",
      paymentRecorded: "Pagamento registrado!",
      paymentUpdated: "Pagamento atualizado!",
      paymentDeleted: "Pagamento excluído!",
      statusChanged: "Status alterado para",
      registrationsOpened: "Inscrições abertas com sucesso!",
      registrationsClosed: "Inscrições encerradas",
      registrationsReopened: "Inscrições reabertas",
      gameDeleted: "Jogo excluído",
      playerRemoved: "Jogador removido",
      playerPreselected: "pré-selecionado",
      playersSelected: "jogador(es) selecionado(s) pelo nome",
      // Error messages
      errorLoadingData: "Erro ao carregar dados",
      errorLoadingPlayers: "Erro ao carregar jogadores",
      errorLoadingRanking: "Erro ao carregar ranking",
      errorLoadingHistory: "Erro ao carregar histórico",
      errorLoadingStats: "Erro ao carregar estatísticas",
      errorLoadingEvaluations: "Erro ao carregar avaliações",
      errorLoadingInvites: "Erro ao carregar convites",
      errorLoadingEvents: "Erro ao carregar eventos",
      errorLoadingConfig: "Erro ao carregar configurações",
      errorLoadingGames: "Erro ao carregar jogos",
      errorLoadingUsers: "Erro ao carregar usuários",
      errorLoadingEvaluators: "Erro ao carregar avaliadores",
      errorLoadingPreview: "Erro ao carregar preview",
      errorAddingPlayer: "Erro ao adicionar",
      errorUpdatingPlayer: "Erro ao atualizar",
      errorDeletingPlayer: "Erro ao excluir",
      errorApproving: "Erro ao aprovar jogador",
      errorRejecting: "Erro ao rejeitar jogador",
      errorPhotoUpload: "Erro no upload",
      errorUpdatingProfile: "Erro ao atualizar perfil",
      errorChangingPassword: "Erro ao alterar senha",
      errorSendingEvaluation: "Erro ao enviar avaliação",
      errorDeletingEvaluation: "Erro ao excluir avaliação",
      errorCreatingEvaluator: "Erro ao criar avaliador",
      errorDeletingEvaluators: "Erro ao excluir avaliadores",
      errorRegisteringEvaluator: "Erro ao cadastrar avaliador",
      errorSavingPermissions: "Erro ao salvar permissões",
      errorGeneratingTeams: "Erro ao gerar times",
      errorPublishingTeams: "Erro ao publicar times",
      errorComparingPlayers: "Erro ao comparar jogadores",
      errorComparingTeams: "Erro ao comparar times",
      errorGeneratingLink: "Erro ao gerar link",
      errorCopying: "Erro ao copiar",
      errorSendingInvite: "Erro ao criar convite",
      errorResendingEmail: "Erro ao reenviar email",
      errorDeletingInvite: "Erro ao excluir convite",
      errorSavingReference: "Erro ao salvar jogador parâmetro",
      errorSavingSetterReference: "Erro ao salvar levantador parâmetro",
      errorMakingEvaluator: "Erro ao criar avaliador",
      errorDeletingHistory: "Erro ao apagar histórico",
      errorRegistration: "Erro ao realizar cadastro",
      errorLinking: "Erro ao vincular",
      errorUnlinking: "Erro ao desvincular",
      errorSavingConfig: "Erro ao salvar configurações",
      errorSendingReport: "Erro ao enviar relatório",
      errorSavingEvent: "Erro ao salvar evento",
      errorDeletingEvent: "Erro ao excluir evento",
      errorSavingAttendance: "Erro ao salvar frequência",
      errorCreatingTeam: "Erro ao cadastrar time",
      errorDeletingTeam: "Erro ao excluir time",
      errorAssigningPlayer: "Erro ao atribuir jogador",
      errorSavingPayment: "Erro ao salvar pagamento",
      errorDeletingPayment: "Erro ao excluir pagamento",
      errorChangingStatus: "Erro ao alterar status",
      errorCreatingGame: "Erro ao criar jogo",
      errorUpdatingStatus: "Erro ao atualizar status",
      errorDeletingGame: "Erro ao excluir jogo",
      errorRemovingPlayer: "Erro ao remover jogador",
      errorExportExcel: "Erro ao exportar para Excel",
      errorExportPDF: "Erro ao exportar PDF",
      errorExportSummary: "Erro ao exportar resumo de jogadores",
      errorCheckingPlayers: "Erro ao verificar jogadores",
      errorClearingPlayers: "Erro ao limpar jogadores",
      errorChangingConfig: "Erro ao alterar configuração",
      errorInviteExpired: "Convite não encontrado ou expirado",
      // Validation messages
      fillAllFields: "Preencha todos os campos",
      fillNamePositon: "Preencha nome, sobrenome e posição",
      fillEmailPassword: "Preencha email e senha",
      selectPlayer: "Selecione um jogador para avaliar",
      selectTwoPlayers: "Selecione dois jogadores para comparar",
      selectDifferentPlayers: "Selecione jogadores diferentes",
      selectTwoTeams: "Selecione dois times para comparar",
      selectDifferentTeams: "Selecione times diferentes",
      selectDate: "Selecione uma data",
      enterTeamName: "Digite o nome do time",
      enterNewPassword: "Digite uma nova senha",
      enterValidEmail: "Digite um e-mail válido",
      emailAlreadyAdded: "E-mail já adicionado",
      addRecipient: "Adicione pelo menos um destinatário",
      fillTitleDate: "Preencha título e data",
      fillPlayerValueDate: "Preencha jogador, valor e data",
      emailRequired: "Email é obrigatório",
      passwordMinLength: "A senha deve ter pelo menos 4 caracteres",
      passwordsDoNotMatch: "As senhas não coincidem",
      nameRequired: "O nome é obrigatório",
      invalidEmail: "Formato de email inválido",
      phoneRequired: "Informe seu telefone",
      birthDateRequired: "Informe sua data de nascimento",
      sessionExpired: "Sessão expirada. Faça login novamente.",
      pasteNamesFirst: "Cole os nomes dos jogadores primeiro",
      noValidNames: "Nenhum nome válido encontrado",
      maxPlayersSelected: "Máximo de 18 jogadores já selecionados",
      selectExactly18: "Selecione exatamente 18 jogadores",
      selectMinSetters: "Selecione pelo menos 3 levantadores jogando como LEVANTADOR. Atualmente:",
      generateTeamsFirst: "Gere os times primeiro",
      noTeamsToShare: "Nenhum time gerado para compartilhar",
      namesNotFound: "Nomes não encontrados:",
      useOnlyImages: "Use apenas JPG, PNG, GIF ou WEBP",
      maxFileSize: "Máximo 10MB",
      fileTooLarge: "Arquivo muito grande. Máximo 10MB.",
      formatNotSupported: "Formato não suportado. Use JPG, PNG, GIF ou WebP.",
      fillRequiredFields: "Preencha todos os campos obrigatórios",
    },
  },

  en: {
    // Login Page
    login: {
      title: "VolleyPro Analytics",
      subtitle: "Player Evaluation System",
      playerTab: "I'M A PLAYER",
      evaluatorTab: "I'M AN EVALUATOR",
      email: "Email",
      password: "Password",
      enterButton: "Enter",
      registering: "Registering...",
      entering: "Entering...",
      invalidCredentials: "Invalid credentials",
      registerSuccess: "Registration submitted! Await admin approval.",
      // Registration
      register: "Register",
      firstName: "First Name",
      lastName: "Last Name",
      position: "Position",
      position2: "2nd Position (optional)",
      phone: "Phone",
      birthDate: "Birth Date",
      photo: "Photo",
      selectPhoto: "Select Photo",
      gallery: "Gallery",
      camera: "Camera",
      requiredFields: "* Required fields",
      awaitingApproval: "Your registration will be reviewed by admin",
      alreadyHaveAccount: "Already have an account?",
      dontHaveAccount: "Don't have an account?",
      clickHere: "Click here",
      // Player login
      findYourName: "Find your name in the list and enter your password",
      searchYourName: "Search your name",
      typeYourName: "Type your name...",
      selectYourName: "Select your name",
      chooseYourName: "Choose your name...",
      enterPassword: "Enter password",
      selectPlayer: "Select your name from the list",
      // Evaluator login
      evaluatorAccess: "Access for coaches, evaluators and administrators",
    },
    // Positions
    positions: {
      ponteiro: "Outside Hitter",
      oposto: "Opposite",
      central: "Middle Blocker",
      levantador: "Setter",
      libero: "Libero",
    },
    // Navigation
    nav: {
      home: "Home",
      players: "Players",
      evaluators: "Evaluators",
      evaluate: "Evaluate",
      ranking: "Ranking",
      statistics: "Statistics",
      gameday: "Game Day",
      permissions: "Permissions",
      settings: "Settings",
      logout: "Logout",
    },
    // Dashboard
    dashboard: {
      welcome: "Welcome",
      totalPlayers: "Total Players",
      totalEvaluations: "Total Evaluations",
      pendingApproval: "Pending Approval",
      recentActivity: "Recent Activity",
    },
    // Players
    players: {
      title: "Players",
      searchPlaceholder: "Search player...",
      noPlayers: "No players found",
      average: "Average",
      evaluations: "evaluations",
      edit: "Edit",
      delete: "Delete",
      history: "History",
      makeEvaluator: "Make Evaluator",
      pending: "Pending",
      approved: "Approved",
      playersFound: "player(s)",
    },
    // Evaluation
    evaluation: {
      title: "Evaluate Player",
      selectPlayer: "Select a player",
      skills: "Skills",
      attack: "Attack",
      pass: "Pass",
      defense: "Defense",
      serve: "Serve",
      block: "Block",
      setting: "Setting",
      skill: "Technique",
      comments: "Comments",
      commentsPlaceholder: "Observations about the player...",
      submit: "Submit Evaluation",
      submitting: "Submitting...",
      success: "Evaluation submitted successfully!",
      error: "Error submitting evaluation",
    },
    // Ranking
    ranking: {
      title: "Player Ranking",
      position: "Position",
      player: "Player",
      overall: "Overall Average",
      compare: "Compare",
      selectPlayer1: "Select Player 1",
      selectPlayer2: "Select Player 2",
      compareButton: "Compare Players",
    },
    // Game Day
    gameday: {
      title: "Game Day",
      selectPlayers: "Select Players",
      generateTeams: "Generate Balanced Teams",
      generating: "Generating...",
      publishTeams: "Publish Teams",
      publishing: "Publishing...",
      published: "Teams published!",
      shareWhatsApp: "Share on WhatsApp",
      team: "Team",
      power: "Power",
      winProbability: "Win Probability",
      mvp: "MVP",
      recentGames: "Recent Games",
      location: "Location",
      startTime: "Start Time",
      endTime: "End Time",
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      yes: "Yes",
      no: "No",
      all: "All",
      none: "None",
      search: "Search",
      filter: "Filter",
      noData: "No data",
      language: "Language",
      select: "Select",
      optional: "Optional",
    },
    // Admin - Evaluations Panel
    evaluationsPanel: {
      title: "Evaluations Panel",
      subtitle: "View all player evaluations performed on the platform",
      searchPlayer: "Search player name...",
      allPlayers: "All players",
      allEvaluators: "All evaluators",
      last30: "Last 30 days",
      last90: "Last 90 days",
      allPeriod: "All",
      results: "result(s)",
      selectByEvaluator: "Select by Evaluator",
      selectAll: "Select All",
      exportEvaluations: "Export Evaluations",
      exportPlayers: "Export Players",
      exportPDF: "Export PDF",
      allEvaluations: "All Evaluations",
      viewDetails: "View details",
      edit: "Edit",
      deleteSelected: "Delete Selected",
      confirmBulkDelete: "Bulk Delete Evaluations",
      cannotUndo: "This action cannot be undone!",
      noEvaluations: "No evaluations found",
      adjustFilters: "Adjust filters to find evaluations",
    },
    // Admin - Game Registrations
    gameRegistrations: {
      title: "Game Registrations",
      subtitle: "Open registrations and manage players",
      enabled: "Enabled",
      disabled: "Disabled",
      openRegistrations: "Open Registrations",
      newRegistrations: "Open New Registrations",
      gameTitle: "Title",
      date: "Date",
      time: "Time",
      location: "Location",
      locationPlaceholder: "Court, address...",
      maxPlayers: "Maximum Players",
      guestDeadline: "Guest Deadline",
      guestDeadlineHint: "Until this deadline, only group members can register.",
      games: "Games",
      noRegistrations: "No open registrations",
      clickOpen: "Click 'Open Registrations'",
      open: "Open",
      closed: "Closed",
      waiting: "waiting",
      selectGame: "Select a game to view details",
      orOpenNew: "Or open new registrations",
      generateTeams: "Generate Teams",
      closeBtn: "Close",
      reopenBtn: "Reopen",
      payments: "Payments",
      registeredPlayers: "Registered Players",
      spots: "spot(s)",
      noPlayersRegistered: "No players registered",
      waitlistTitle: "Waitlist",
      emptyWaitlist: "Waitlist is empty",
      promoteSpots: "Promote Spots",
      member: "Member",
      guest: "Guest",
      paid: "Paid",
      hoursLeft: "h left",
      expiring: "Expiring",
      editGameTitle: "Edit Game",
      saveChanges: "Save Changes",
      deadlineExpired: "expired - spots open for everyone",
      membersOnly: "members only",
      defaultGameTitle: "Game of the Day",
    },
    // Admin - Evaluators
    evaluatorsAdmin: {
      title: "Evaluators",
      subtitle: "Manage evaluators, coaches and administrators",
      addEvaluator: "Add Evaluator",
      newEvaluator: "New Evaluator",
      name: "Name",
      email: "Email",
      password: "Password",
      role: "Access Level",
      admin: "Administrator",
      adminDesc: "Full access",
      coach: "Coach",
      coachDesc: "Teams, statistics, players",
      evaluator: "Evaluator",
      evaluatorDesc: "Evaluate only",
      linkedPlayer: "Linked Player",
      link: "Link",
      unlink: "Unlink",
      active: "Active",
      inactive: "Inactive",
      editEvaluator: "Edit Evaluator",
      noEvaluators: "No evaluators registered",
      searchPlaceholder: "Search evaluator...",
    },
    // Admin - Permissions
    permissionsAdmin: {
      title: "Manage Permissions",
      subtitle: "Configure access for each evaluator level",
      adminOnly: "Admin Only",
      save: "Save Permissions",
    },
    // Admin - Payments
    paymentsAdmin: {
      title: "Payments",
      subtitle: "Manage all player payments",
      totalCollected: "Total Collected",
      totalPending: "Total Pending",
      paymentHistory: "Payment History",
      newPayment: "New Payment",
      player: "Player",
      amount: "Amount",
      dateLabel: "Date",
      description: "Description",
      status: "Status",
      paid: "Paid",
      pending: "Pending",
      noPayments: "No payments found",
      gameFee: "Game Fee",
    },
    // Admin - Weekly Report
    weeklyReport: {
      title: "Weekly Report",
      subtitle: "Configure automatic report delivery",
      enabled: "Enabled",
      disabled: "Disabled",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      recipients: "Recipients",
      addEmail: "Add email",
      save: "Save Settings",
      sendNow: "Send Now",
      sending: "Sending...",
    },
    // Player Dashboard
    playerDashboard: {
      editProfile: "Edit Profile",
      yourFirstName: "Your first name",
      yourLastName: "Your last name",
      mainPosition: "Main Position",
      secondaryPosition: "Secondary Position",
      changePassword: "Change Password",
      newPassword: "New Password",
      enterNewPassword: "Enter new password",
      confirmPassword: "Confirm Password",
      confirmNewPassword: "Confirm new password",
      myInfo: "My Information",
      noContactInfo: "Click the edit icon next to your name to add email and phone.",
      games: "Games",
      teammates: "Teammates",
      lineups: "Lineups",
      upcomingGames: "Upcoming Games",
      register: "Register",
      unregister: "Unregister",
      registered: "Registered",
      full: "Full",
      spots: "spots",
      calendar: "Calendar",
      gameCalendar: "Game Calendar",
      mostPlayedWith: "Most played with",
      leastPlayedWith: "Least played with",
      gamesPlayed: "games",
      noTeammates: "Play more games to see teammate statistics!",
      registerSuccess: "Registration confirmed!",
      unregisterSuccess: "Registration cancelled",
      noGameOnDate: "No game on this date",
      legend: "Legend",
      scheduledGame: "Scheduled game",
      youParticipated: "You participated",
      myTeams: "My Teams",
      noTeamsYet: "You haven't participated in any teams yet",
      gameOfDay: "Game of the Day",
      youPlayed: "You played",
      confirmUnregister: "Are you sure you want to cancel registration?",
      registrationsClosed: "Registrations closed",
      yourTeam: "Your Team",
      viewAllTeams: "View all teams",
    },
    // Toast Messages
    toasts: {
      // Success messages
      playerApproved: "Player approved successfully! An email was sent.",
      playerRejected: "Registration rejected and removed",
      playerAdded: "Player added!",
      playerUpdated: "Player updated!",
      playerDeleted: "Player deleted!",
      playersDeleted: "players deleted!",
      photoUploaded: "Photo uploaded to cloud!",
      profileUpdated: "Profile updated!",
      passwordChanged: "Password changed successfully!",
      evaluationSent: "Evaluation submitted successfully!",
      evaluationDeleted: "Evaluation deleted successfully",
      evaluatorCreated: "Evaluator registered successfully!",
      evaluatorDeleted: "Evaluator deleted successfully!",
      evaluatorActivated: "Evaluator activated",
      evaluatorDeactivated: "Evaluator deactivated",
      roleUpdated: "Access level updated",
      permissionsSaved: "Permissions saved successfully!",
      teamsGenerated: "Teams generated! Click 'Publish' to send to players.",
      teamsPublished: "Teams published! Player order saved.",
      openingWhatsApp: "Opening WhatsApp...",
      linkCopied: "Link copied!",
      inviteSent: "Invite sent successfully!",
      emailResent: "Email resent!",
      inviteDeleted: "Invite deleted",
      referencePlayerUpdated: "Reference player updated",
      referenceSetterUpdated: "Reference setter updated",
      madeEvaluator: "is now",
      successfully: "successfully!",
      historyDeleted: "History deleted successfully",
      registrationSuccess: "Registration completed successfully!",
      linkedPlayer: "Evaluator linked to player successfully!",
      unlinkedPlayer: "Link removed successfully!",
      configSaved: "Settings saved successfully!",
      reportSent: "Report sent successfully!",
      eventCreated: "Event created!",
      eventUpdated: "Event updated!",
      eventDeleted: "Event deleted!",
      attendanceSaved: "Attendance saved successfully!",
      teamCreated: "Team registered successfully!",
      teamDeleted: "Team deleted successfully!",
      playerAssigned: "Player assigned to team!",
      paymentRecorded: "Payment recorded!",
      paymentUpdated: "Payment updated!",
      paymentDeleted: "Payment deleted!",
      statusChanged: "Status changed to",
      registrationsOpened: "Registrations opened successfully!",
      registrationsClosed: "Registrations closed",
      registrationsReopened: "Registrations reopened",
      gameDeleted: "Game deleted",
      playerRemoved: "Player removed",
      playerPreselected: "pre-selected",
      playersSelected: "player(s) selected by name",
      // Error messages
      errorLoadingData: "Error loading data",
      errorLoadingPlayers: "Error loading players",
      errorLoadingRanking: "Error loading ranking",
      errorLoadingHistory: "Error loading history",
      errorLoadingStats: "Error loading statistics",
      errorLoadingEvaluations: "Error loading evaluations",
      errorLoadingInvites: "Error loading invites",
      errorLoadingEvents: "Error loading events",
      errorLoadingConfig: "Error loading settings",
      errorLoadingGames: "Error loading games",
      errorLoadingUsers: "Error loading users",
      errorLoadingEvaluators: "Error loading evaluators",
      errorLoadingPreview: "Error loading preview",
      errorAddingPlayer: "Error adding player",
      errorUpdatingPlayer: "Error updating player",
      errorDeletingPlayer: "Error deleting player",
      errorApproving: "Error approving player",
      errorRejecting: "Error rejecting player",
      errorPhotoUpload: "Upload error",
      errorUpdatingProfile: "Error updating profile",
      errorChangingPassword: "Error changing password",
      errorSendingEvaluation: "Error submitting evaluation",
      errorDeletingEvaluation: "Error deleting evaluation",
      errorCreatingEvaluator: "Error creating evaluator",
      errorDeletingEvaluators: "Error deleting evaluators",
      errorRegisteringEvaluator: "Error registering evaluator",
      errorSavingPermissions: "Error saving permissions",
      errorGeneratingTeams: "Error generating teams",
      errorPublishingTeams: "Error publishing teams",
      errorComparingPlayers: "Error comparing players",
      errorComparingTeams: "Error comparing teams",
      errorGeneratingLink: "Error generating link",
      errorCopying: "Error copying",
      errorSendingInvite: "Error creating invite",
      errorResendingEmail: "Error resending email",
      errorDeletingInvite: "Error deleting invite",
      errorSavingReference: "Error saving reference player",
      errorSavingSetterReference: "Error saving reference setter",
      errorMakingEvaluator: "Error creating evaluator",
      errorDeletingHistory: "Error deleting history",
      errorRegistration: "Error registering",
      errorLinking: "Error linking",
      errorUnlinking: "Error unlinking",
      errorSavingConfig: "Error saving settings",
      errorSendingReport: "Error sending report",
      errorSavingEvent: "Error saving event",
      errorDeletingEvent: "Error deleting event",
      errorSavingAttendance: "Error saving attendance",
      errorCreatingTeam: "Error registering team",
      errorDeletingTeam: "Error deleting team",
      errorAssigningPlayer: "Error assigning player",
      errorSavingPayment: "Error saving payment",
      errorDeletingPayment: "Error deleting payment",
      errorChangingStatus: "Error changing status",
      errorCreatingGame: "Error creating game",
      errorUpdatingStatus: "Error updating status",
      errorDeletingGame: "Error deleting game",
      errorRemovingPlayer: "Error removing player",
      errorExportExcel: "Error exporting to Excel",
      errorExportPDF: "Error exporting PDF",
      errorExportSummary: "Error exporting player summary",
      errorCheckingPlayers: "Error checking players",
      errorClearingPlayers: "Error clearing players",
      errorChangingConfig: "Error changing configuration",
      errorInviteExpired: "Invite not found or expired",
      // Validation messages
      fillAllFields: "Fill in all fields",
      fillNamePositon: "Fill in name, surname and position",
      fillEmailPassword: "Fill in email and password",
      selectPlayer: "Select a player to evaluate",
      selectTwoPlayers: "Select two players to compare",
      selectDifferentPlayers: "Select different players",
      selectTwoTeams: "Select two teams to compare",
      selectDifferentTeams: "Select different teams",
      selectDate: "Select a date",
      enterTeamName: "Enter team name",
      enterNewPassword: "Enter a new password",
      enterValidEmail: "Enter a valid email",
      emailAlreadyAdded: "Email already added",
      addRecipient: "Add at least one recipient",
      fillTitleDate: "Fill in title and date",
      fillPlayerValueDate: "Fill in player, value and date",
      emailRequired: "Email is required",
      passwordMinLength: "Password must be at least 4 characters",
      passwordsDoNotMatch: "Passwords do not match",
      nameRequired: "Name is required",
      invalidEmail: "Invalid email format",
      phoneRequired: "Please enter your phone",
      birthDateRequired: "Please enter your birth date",
      sessionExpired: "Session expired. Please log in again.",
      pasteNamesFirst: "Paste player names first",
      noValidNames: "No valid names found",
      maxPlayersSelected: "Maximum of 18 players already selected",
      selectExactly18: "Select exactly 18 players",
      selectMinSetters: "Select at least 3 setters playing as SETTER. Currently:",
      generateTeamsFirst: "Generate teams first",
      noTeamsToShare: "No teams generated to share",
      namesNotFound: "Names not found:",
      useOnlyImages: "Use only JPG, PNG, GIF or WEBP",
      maxFileSize: "Maximum 10MB",
      fileTooLarge: "File too large. Maximum 10MB.",
      formatNotSupported: "Format not supported. Use JPG, PNG, GIF or WebP.",
      fillRequiredFields: "Fill in all required fields",
    },
  },

  es: {
    // Login Page
    login: {
      title: "VolleyPro Analytics",
      subtitle: "Sistema de Evaluación de Jugadores",
      playerTab: "SOY JUGADOR",
      evaluatorTab: "SOY EVALUADOR",
      email: "Correo electrónico",
      password: "Contraseña",
      enterButton: "Entrar",
      registering: "Registrando...",
      entering: "Entrando...",
      invalidCredentials: "Credenciales inválidas",
      registerSuccess: "¡Registro enviado! Espere la aprobación del administrador.",
      // Registration
      register: "Registrar",
      firstName: "Nombre",
      lastName: "Apellido",
      position: "Posición",
      position2: "2ª Posición (opcional)",
      phone: "Teléfono",
      birthDate: "Fecha de Nacimiento",
      photo: "Foto",
      selectPhoto: "Seleccionar Foto",
      gallery: "Galería",
      camera: "Cámara",
      requiredFields: "* Campos obligatorios",
      awaitingApproval: "Su registro será revisado por el administrador",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      dontHaveAccount: "¿No tienes cuenta?",
      clickHere: "Haz clic aquí",
      // Player login
      findYourName: "Encuentra tu nombre en la lista e ingresa tu contraseña",
      searchYourName: "Buscar tu nombre",
      typeYourName: "Escribe tu nombre...",
      selectYourName: "Selecciona tu nombre",
      chooseYourName: "Elige tu nombre...",
      enterPassword: "Ingresa la contraseña",
      selectPlayer: "Selecciona tu nombre de la lista",
      // Evaluator login
      evaluatorAccess: "Acceso para entrenadores, evaluadores y administradores",
    },
    // Positions
    positions: {
      ponteiro: "Receptor",
      oposto: "Opuesto",
      central: "Central",
      levantador: "Colocador",
      libero: "Líbero",
    },
    // Navigation
    nav: {
      home: "Inicio",
      players: "Jugadores",
      evaluators: "Evaluadores",
      evaluate: "Evaluar",
      ranking: "Ranking",
      statistics: "Estadísticas",
      gameday: "Equipos del Día",
      permissions: "Permisos",
      settings: "Configuración",
      logout: "Salir",
    },
    // Dashboard
    dashboard: {
      welcome: "Bienvenido",
      totalPlayers: "Total de Jugadores",
      totalEvaluations: "Total de Evaluaciones",
      pendingApproval: "Pendiente de Aprobación",
      recentActivity: "Actividad Reciente",
    },
    // Players
    players: {
      title: "Jugadores",
      searchPlaceholder: "Buscar jugador...",
      noPlayers: "No se encontraron jugadores",
      average: "Promedio",
      evaluations: "evaluaciones",
      edit: "Editar",
      delete: "Eliminar",
      history: "Historial",
      makeEvaluator: "Hacer Evaluador",
      pending: "Pendientes",
      approved: "Aprobados",
      playersFound: "jugador(es)",
    },
    // Evaluation
    evaluation: {
      title: "Evaluar Jugador",
      selectPlayer: "Seleccione un jugador",
      skills: "Habilidades",
      attack: "Ataque",
      pass: "Pase",
      defense: "Defensa",
      serve: "Saque",
      block: "Bloqueo",
      setting: "Colocación",
      skill: "Técnica",
      comments: "Comentarios",
      commentsPlaceholder: "Observaciones sobre el jugador...",
      submit: "Enviar Evaluación",
      submitting: "Enviando...",
      success: "¡Evaluación enviada con éxito!",
      error: "Error al enviar evaluación",
    },
    // Ranking
    ranking: {
      title: "Ranking de Jugadores",
      position: "Posición",
      player: "Jugador",
      overall: "Promedio General",
      compare: "Comparar",
      selectPlayer1: "Seleccione Jugador 1",
      selectPlayer2: "Seleccione Jugador 2",
      compareButton: "Comparar Jugadores",
    },
    // Game Day
    gameday: {
      title: "Equipos del Día",
      selectPlayers: "Seleccionar Jugadores",
      generateTeams: "Generar Equipos Equilibrados",
      generating: "Generando...",
      publishTeams: "Publicar Equipos",
      publishing: "Publicando...",
      published: "¡Equipos publicados!",
      shareWhatsApp: "Compartir en WhatsApp",
      team: "Equipo",
      power: "Poder",
      winProbability: "Prob. Victoria",
      mvp: "MVP",
      recentGames: "Juegos Recientes",
      location: "Ubicación",
      startTime: "Hora de Inicio",
      endTime: "Hora de Fin",
    },
    // Common
    common: {
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      delete: "Eliminar",
      edit: "Editar",
      back: "Volver",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      yes: "Sí",
      no: "No",
      all: "Todos",
      none: "Ninguno",
      search: "Buscar",
      filter: "Filtrar",
      noData: "Sin datos",
      language: "Idioma",
      select: "Seleccionar",
      optional: "Opcional",
    },
    // Admin - Evaluations Panel
    evaluationsPanel: {
      title: "Panel de Evaluaciones",
      subtitle: "Visualice todas las evaluaciones de jugadores realizadas en la plataforma",
      searchPlayer: "Buscar jugador...",
      allPlayers: "Todos los jugadores",
      allEvaluators: "Todos los evaluadores",
      last30: "Últimos 30 días",
      last90: "Últimos 90 días",
      allPeriod: "Todos",
      results: "resultado(s)",
      selectByEvaluator: "Seleccionar por Evaluador",
      selectAll: "Seleccionar Todos",
      exportEvaluations: "Exportar Evaluaciones",
      exportPlayers: "Exportar Jugadores",
      exportPDF: "Exportar PDF",
      allEvaluations: "Todas las Evaluaciones",
      viewDetails: "Ver detalles",
      edit: "Editar",
      deleteSelected: "Eliminar Seleccionados",
      confirmBulkDelete: "Eliminar Evaluaciones en Lote",
      cannotUndo: "¡Esta acción no se puede deshacer!",
      noEvaluations: "No se encontraron evaluaciones",
      adjustFilters: "Ajuste los filtros para encontrar evaluaciones",
    },
    // Admin - Game Registrations
    gameRegistrations: {
      title: "Inscripciones para Juegos",
      subtitle: "Abra inscripciones y gestione jugadores",
      enabled: "Habilitadas",
      disabled: "Bloqueadas",
      openRegistrations: "Abrir Inscripciones",
      newRegistrations: "Abrir Nuevas Inscripciones",
      gameTitle: "Título",
      date: "Fecha",
      time: "Horario",
      location: "Ubicación",
      locationPlaceholder: "Cancha, dirección...",
      maxPlayers: "Máximo de Jugadores",
      guestDeadline: "Plazo Invitados",
      guestDeadlineHint: "Hasta este plazo, solo los miembros del grupo pueden inscribirse.",
      games: "Juegos",
      noRegistrations: "Ninguna inscripción abierta",
      clickOpen: "Haz clic en 'Abrir Inscripciones'",
      open: "Abierto",
      closed: "Cerrado",
      waiting: "espera",
      selectGame: "Seleccione un juego para ver detalles",
      orOpenNew: "O abra nuevas inscripciones",
      generateTeams: "Generar Equipos",
      closeBtn: "Cerrar",
      reopenBtn: "Reabrir",
      payments: "Pagos",
      registeredPlayers: "Jugadores Inscritos",
      spots: "plaza(s)",
      noPlayersRegistered: "Ningún jugador inscrito",
      waitlistTitle: "Lista de Espera",
      emptyWaitlist: "Lista de espera vacía",
      promoteSpots: "Promover Plazas",
      member: "Miembro",
      guest: "Invitado",
      paid: "Pagado",
      hoursLeft: "h restantes",
      expiring: "Expirando",
      editGameTitle: "Editar Juego",
      saveChanges: "Guardar Cambios",
      deadlineExpired: "expirado - plazas abiertas para todos",
      membersOnly: "solo miembros",
      defaultGameTitle: "Juego del Día",
    },
    // Admin - Evaluators
    evaluatorsAdmin: {
      title: "Evaluadores",
      subtitle: "Gestione evaluadores, entrenadores y administradores",
      addEvaluator: "Agregar Evaluador",
      newEvaluator: "Nuevo Evaluador",
      name: "Nombre",
      email: "Correo electrónico",
      password: "Contraseña",
      role: "Nivel de Acceso",
      admin: "Administrador",
      adminDesc: "Acceso total",
      coach: "Entrenador",
      coachDesc: "Equipos, estadísticas, jugadores",
      evaluator: "Evaluador",
      evaluatorDesc: "Solo evaluar",
      linkedPlayer: "Jugador Vinculado",
      link: "Vincular",
      unlink: "Desvincular",
      active: "Activo",
      inactive: "Inactivo",
      editEvaluator: "Editar Evaluador",
      noEvaluators: "Ningún evaluador registrado",
      searchPlaceholder: "Buscar evaluador...",
    },
    // Admin - Permissions
    permissionsAdmin: {
      title: "Gestionar Permisos",
      subtitle: "Configure el acceso de cada nivel de evaluador",
      adminOnly: "Solo Admin",
      save: "Guardar Permisos",
    },
    // Admin - Payments
    paymentsAdmin: {
      title: "Pagos",
      subtitle: "Gestione todos los pagos de los jugadores",
      totalCollected: "Total Recaudado",
      totalPending: "Total Pendiente",
      paymentHistory: "Historial de Pagos",
      newPayment: "Nuevo Pago",
      player: "Jugador",
      amount: "Valor",
      dateLabel: "Fecha",
      description: "Descripción",
      status: "Estado",
      paid: "Pagado",
      pending: "Pendiente",
      noPayments: "No se encontraron pagos",
      gameFee: "Tasa del Juego",
    },
    // Admin - Weekly Report
    weeklyReport: {
      title: "Informe Semanal",
      subtitle: "Configure el envío automático de informes",
      enabled: "Activado",
      disabled: "Desactivado",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
      recipients: "Destinatarios",
      addEmail: "Agregar correo",
      save: "Guardar Configuración",
      sendNow: "Enviar Ahora",
      sending: "Enviando...",
    },
    // Player Dashboard
    playerDashboard: {
      editProfile: "Editar Perfil",
      yourFirstName: "Tu primer nombre",
      yourLastName: "Tu apellido",
      mainPosition: "Posición Principal",
      secondaryPosition: "Posición Secundaria",
      changePassword: "Cambiar Contraseña",
      newPassword: "Nueva Contraseña",
      enterNewPassword: "Ingresa la nueva contraseña",
      confirmPassword: "Confirmar Contraseña",
      confirmNewPassword: "Confirma la nueva contraseña",
      myInfo: "Mi Información",
      noContactInfo: "Haz clic en el ícono de editar junto a tu nombre para agregar email y teléfono.",
      games: "Juegos",
      teammates: "Compañeros",
      lineups: "Alineaciones",
      upcomingGames: "Próximos Juegos",
      register: "Inscribirse",
      unregister: "Cancelar Inscripción",
      registered: "Inscrito",
      full: "Lleno",
      spots: "lugares",
      calendar: "Calendario",
      gameCalendar: "Calendario de Juegos",
      mostPlayedWith: "Más jugó con",
      leastPlayedWith: "Menos jugó con",
      gamesPlayed: "juegos",
      noTeammates: "¡Juega más partidos para ver estadísticas de compañeros!",
      registerSuccess: "¡Inscripción confirmada!",
      unregisterSuccess: "Inscripción cancelada",
      noGameOnDate: "Ningún juego en esta fecha",
      legend: "Leyenda",
      scheduledGame: "Juego programado",
      youParticipated: "Participaste",
      myTeams: "Mis Equipos",
      noTeamsYet: "Aún no has participado en ningún equipo",
      gameOfDay: "Juego del Día",
      youPlayed: "Jugaste",
      confirmUnregister: "¿Estás seguro de que deseas cancelar la inscripción?",
      registrationsClosed: "Inscripciones cerradas",
      yourTeam: "Tu Equipo",
      viewAllTeams: "Ver todos los equipos",
    },
    // Toast Messages
    toasts: {
      // Success messages
      playerApproved: "¡Jugador aprobado con éxito! Se envió un email.",
      playerRejected: "Registro rechazado y eliminado",
      playerAdded: "¡Jugador agregado!",
      playerUpdated: "¡Jugador actualizado!",
      playerDeleted: "¡Jugador eliminado!",
      playersDeleted: "¡jugadores eliminados!",
      photoUploaded: "¡Foto subida a la nube!",
      profileUpdated: "¡Perfil actualizado!",
      passwordChanged: "¡Contraseña cambiada con éxito!",
      evaluationSent: "¡Evaluación enviada con éxito!",
      evaluationDeleted: "Evaluación eliminada con éxito",
      evaluatorCreated: "¡Evaluador registrado con éxito!",
      evaluatorDeleted: "¡Evaluador eliminado con éxito!",
      evaluatorActivated: "Evaluador activado",
      evaluatorDeactivated: "Evaluador desactivado",
      roleUpdated: "Nivel de acceso actualizado",
      permissionsSaved: "¡Permisos guardados con éxito!",
      teamsGenerated: "¡Equipos generados! Haz clic en 'Publicar' para enviar a los jugadores.",
      teamsPublished: "¡Equipos publicados! El orden de los jugadores fue guardado.",
      openingWhatsApp: "Abriendo WhatsApp...",
      linkCopied: "¡Link copiado!",
      inviteSent: "¡Invitación enviada con éxito!",
      emailResent: "¡Email reenviado!",
      inviteDeleted: "Invitación eliminada",
      referencePlayerUpdated: "Jugador de referencia actualizado",
      referenceSetterUpdated: "Colocador de referencia actualizado",
      madeEvaluator: "ahora es",
      successfully: "¡con éxito!",
      historyDeleted: "Historial eliminado con éxito",
      registrationSuccess: "¡Registro completado con éxito!",
      linkedPlayer: "¡Evaluador vinculado al jugador con éxito!",
      unlinkedPlayer: "¡Vínculo eliminado con éxito!",
      configSaved: "¡Configuración guardada con éxito!",
      reportSent: "¡Informe enviado con éxito!",
      eventCreated: "¡Evento creado!",
      eventUpdated: "¡Evento actualizado!",
      eventDeleted: "¡Evento eliminado!",
      attendanceSaved: "¡Asistencia guardada con éxito!",
      teamCreated: "¡Equipo registrado con éxito!",
      teamDeleted: "¡Equipo eliminado con éxito!",
      playerAssigned: "¡Jugador asignado al equipo!",
      paymentRecorded: "¡Pago registrado!",
      paymentUpdated: "¡Pago actualizado!",
      paymentDeleted: "¡Pago eliminado!",
      statusChanged: "Estado cambiado a",
      registrationsOpened: "¡Inscripciones abiertas con éxito!",
      registrationsClosed: "Inscripciones cerradas",
      registrationsReopened: "Inscripciones reabiertas",
      gameDeleted: "Juego eliminado",
      playerRemoved: "Jugador eliminado",
      playerPreselected: "preseleccionado",
      playersSelected: "jugador(es) seleccionado(s) por nombre",
      // Error messages
      errorLoadingData: "Error al cargar datos",
      errorLoadingPlayers: "Error al cargar jugadores",
      errorLoadingRanking: "Error al cargar ranking",
      errorLoadingHistory: "Error al cargar historial",
      errorLoadingStats: "Error al cargar estadísticas",
      errorLoadingEvaluations: "Error al cargar evaluaciones",
      errorLoadingInvites: "Error al cargar invitaciones",
      errorLoadingEvents: "Error al cargar eventos",
      errorLoadingConfig: "Error al cargar configuración",
      errorLoadingGames: "Error al cargar juegos",
      errorLoadingUsers: "Error al cargar usuarios",
      errorLoadingEvaluators: "Error al cargar evaluadores",
      errorLoadingPreview: "Error al cargar vista previa",
      errorAddingPlayer: "Error al agregar jugador",
      errorUpdatingPlayer: "Error al actualizar jugador",
      errorDeletingPlayer: "Error al eliminar jugador",
      errorApproving: "Error al aprobar jugador",
      errorRejecting: "Error al rechazar jugador",
      errorPhotoUpload: "Error en la subida",
      errorUpdatingProfile: "Error al actualizar perfil",
      errorChangingPassword: "Error al cambiar contraseña",
      errorSendingEvaluation: "Error al enviar evaluación",
      errorDeletingEvaluation: "Error al eliminar evaluación",
      errorCreatingEvaluator: "Error al crear evaluador",
      errorDeletingEvaluators: "Error al eliminar evaluadores",
      errorRegisteringEvaluator: "Error al registrar evaluador",
      errorSavingPermissions: "Error al guardar permisos",
      errorGeneratingTeams: "Error al generar equipos",
      errorPublishingTeams: "Error al publicar equipos",
      errorComparingPlayers: "Error al comparar jugadores",
      errorComparingTeams: "Error al comparar equipos",
      errorGeneratingLink: "Error al generar link",
      errorCopying: "Error al copiar",
      errorSendingInvite: "Error al crear invitación",
      errorResendingEmail: "Error al reenviar email",
      errorDeletingInvite: "Error al eliminar invitación",
      errorSavingReference: "Error al guardar jugador de referencia",
      errorSavingSetterReference: "Error al guardar colocador de referencia",
      errorMakingEvaluator: "Error al crear evaluador",
      errorDeletingHistory: "Error al eliminar historial",
      errorRegistration: "Error al registrar",
      errorLinking: "Error al vincular",
      errorUnlinking: "Error al desvincular",
      errorSavingConfig: "Error al guardar configuración",
      errorSendingReport: "Error al enviar informe",
      errorSavingEvent: "Error al guardar evento",
      errorDeletingEvent: "Error al eliminar evento",
      errorSavingAttendance: "Error al guardar asistencia",
      errorCreatingTeam: "Error al registrar equipo",
      errorDeletingTeam: "Error al eliminar equipo",
      errorAssigningPlayer: "Error al asignar jugador",
      errorSavingPayment: "Error al guardar pago",
      errorDeletingPayment: "Error al eliminar pago",
      errorChangingStatus: "Error al cambiar estado",
      errorCreatingGame: "Error al crear juego",
      errorUpdatingStatus: "Error al actualizar estado",
      errorDeletingGame: "Error al eliminar juego",
      errorRemovingPlayer: "Error al eliminar jugador",
      errorExportExcel: "Error al exportar a Excel",
      errorExportPDF: "Error al exportar PDF",
      errorExportSummary: "Error al exportar resumen de jugadores",
      errorCheckingPlayers: "Error al verificar jugadores",
      errorClearingPlayers: "Error al limpiar jugadores",
      errorChangingConfig: "Error al cambiar configuración",
      errorInviteExpired: "Invitación no encontrada o expirada",
      // Validation messages
      fillAllFields: "Complete todos los campos",
      fillNamePositon: "Complete nombre, apellido y posición",
      fillEmailPassword: "Complete email y contraseña",
      selectPlayer: "Seleccione un jugador para evaluar",
      selectTwoPlayers: "Seleccione dos jugadores para comparar",
      selectDifferentPlayers: "Seleccione jugadores diferentes",
      selectTwoTeams: "Seleccione dos equipos para comparar",
      selectDifferentTeams: "Seleccione equipos diferentes",
      selectDate: "Seleccione una fecha",
      enterTeamName: "Ingrese el nombre del equipo",
      enterNewPassword: "Ingrese una nueva contraseña",
      enterValidEmail: "Ingrese un email válido",
      emailAlreadyAdded: "Email ya agregado",
      addRecipient: "Agregue al menos un destinatario",
      fillTitleDate: "Complete título y fecha",
      fillPlayerValueDate: "Complete jugador, valor y fecha",
      emailRequired: "Email es obligatorio",
      passwordMinLength: "La contraseña debe tener al menos 4 caracteres",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      nameRequired: "El nombre es obligatorio",
      invalidEmail: "Formato de email inválido",
      phoneRequired: "Ingrese su teléfono",
      birthDateRequired: "Ingrese su fecha de nacimiento",
      sessionExpired: "Sesión expirada. Por favor inicie sesión nuevamente.",
      pasteNamesFirst: "Pegue los nombres de los jugadores primero",
      noValidNames: "No se encontraron nombres válidos",
      maxPlayersSelected: "Máximo de 18 jugadores ya seleccionados",
      selectExactly18: "Seleccione exactamente 18 jugadores",
      selectMinSetters: "Seleccione al menos 3 colocadores jugando como COLOCADOR. Actualmente:",
      generateTeamsFirst: "Genere los equipos primero",
      noTeamsToShare: "No hay equipos generados para compartir",
      namesNotFound: "Nombres no encontrados:",
      useOnlyImages: "Use solo JPG, PNG, GIF o WEBP",
      maxFileSize: "Máximo 10MB",
      fileTooLarge: "Archivo muy grande. Máximo 10MB.",
      formatNotSupported: "Formato no soportado. Use JPG, PNG, GIF o WebP.",
      fillRequiredFields: "Complete todos los campos obligatorios",
    },
  },
};

export const LANGUAGES = [
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
];
